import { useState, useCallback } from 'react';
import Cookies from 'js-cookie';

export default function useCookie(name, defaultValue) {
  const [value, setValue] = useState(() => {
    const cookie = Cookies.get(name);
    if (cookie) return cookie;
    Cookies.set(name, defaultValue, { secure: true, sameSite: 'strict' as const });
    return defaultValue;
  });

  const updateCookie = useCallback(
    (newValue, options = {}) => {
      const secureOptions = {
        secure: true,
        httpOnly: false, // Note: httpOnly can't be set from client-side JS
        sameSite: 'strict' as const,
        ...options
      };
      Cookies.set(name, newValue, secureOptions);
      setValue(newValue);
    },
    [name],
  );

  const deleteCookie = useCallback(() => {
    Cookies.remove(name);
    setValue(null);
  }, [name]);

  return [value, updateCookie, deleteCookie];
}
